import React from "react";
import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Contents from "../components/pages/findPassword/Contents";

const FindPassword = () => {
    return (
        <>
            <Header />
            <Contents />
            <Footer />
        </>
    );
};

export default FindPassword;